const NO_PROJECT_PHASE_LABEL = 'No Project Phase';

export const normalizeProjectPhaseSortableId = id => String(id);

export const extractProjectPhasesFromApiPayload = payload => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    return [];
};

export const reorderProjectPhasesByIds = (phases, orderedIds) => {
    if (!Array.isArray(phases) || !Array.isArray(orderedIds) || orderedIds.length === 0) {
        return phases || [];
    }

    const byId = new Map();
    phases.forEach(phase => {
        byId.set(normalizeProjectPhaseSortableId(phase.id), phase);
    });

    const reordered = orderedIds
        .map((id, index) => {
            const phase = byId.get(normalizeProjectPhaseSortableId(id));
            return phase ? { ...phase, order: index } : null;
        })
        .filter(Boolean);

    const reorderedIdSet = new Set(orderedIds.map(normalizeProjectPhaseSortableId));
    const remaining = phases.filter(phase => !reorderedIdSet.has(normalizeProjectPhaseSortableId(phase.id)));

    return sortProjectPhases([...reordered, ...remaining]);
};

export const compareProjectPhasesByOrder = (a, b) => {
    const orderA = Number.isFinite(a?.order) ? a.order : Number.MAX_SAFE_INTEGER;
    const orderB = Number.isFinite(b?.order) ? b.order : Number.MAX_SAFE_INTEGER;
    if (orderA !== orderB) {
        return orderA - orderB;
    }
    return (a?.name || '').localeCompare(b?.name || '');
};

export const sortProjectPhases = phases => {
    if (!Array.isArray(phases)) return [];
    return [...phases].sort(compareProjectPhasesByOrder);
};

export const buildProjectPhaseOrderMap = projectPhases => {
    const orderMap = new Map();
    sortProjectPhases(projectPhases || []).forEach((phase, index) => {
        if (phase?.name) {
            orderMap.set(phase.name, index);
        }
    });
    return orderMap;
};

export const compareProjectPhaseGroupNames = (a, b, projectPhases) => {
    if (a === NO_PROJECT_PHASE_LABEL && b !== NO_PROJECT_PHASE_LABEL) return 1;
    if (b === NO_PROJECT_PHASE_LABEL && a !== NO_PROJECT_PHASE_LABEL) return -1;
    if (a === NO_PROJECT_PHASE_LABEL && b === NO_PROJECT_PHASE_LABEL) return 0;

    const orderMap = buildProjectPhaseOrderMap(projectPhases);
    const orderA = orderMap.has(a) ? orderMap.get(a) : Number.MAX_SAFE_INTEGER;
    const orderB = orderMap.has(b) ? orderMap.get(b) : Number.MAX_SAFE_INTEGER;
    if (orderA !== orderB) {
        return orderA - orderB;
    }
    return a.localeCompare(b);
};

export const sortProjectPhaseNames = (names, projectPhases) => {
    if (!Array.isArray(names)) return [];
    return [...names].sort((a, b) => compareProjectPhaseGroupNames(a, b, projectPhases));
};
